<template>
  <div class="dimmable">
    <div class="ui inverted dimmer transition" :class="{'visible active':loading }">
        <div class="ui text loader">Loading</div>
    </div>
    <step-bar></step-bar>
    <error-message :message-list="errorMessage" v-on:clearMessageList="clearErrorMessage"></error-message>
    <div class="ui hidden divider"></div>
    <products-list :products-list="productsList" v-on:removeSelectedProduct="removeSelectedProduct" v-on:updateQuantity="updateQuantityOfSelectedProduct"></products-list>
    <div class="ui hidden divider"></div>
    <form :action="formActionUrl" method="POST">
        <input type="hidden" name="action" value="process">
        <empty-cart v-if="!anyProductInCart"></empty-cart>
        <comment :in-cart="anyProductInCart" :content="comment"></comment>
        <div class="ui hidden divider"></div>
        <total-price :in-cart="anyProductInCart" 
                     :price="totalWithCurrency" 
                     :show-store-offer-control="isAE"
                     :is-store-offer="isStoreOffer"
                     v-on:storeOfferChanged="applyStoreOffer"></total-price>
        <div class="ui hidden divider"></div>
        <button-collection :in-cart="anyProductInCart" :default-url="defaultActionUrl" v-on:removeAllProducts="openMaskForcheckToRemoveAllProducts"></button-collection>
    </form>
    <div class="ui hidden divider"></div>
    <mask-for-check-to-remove-all-products :show="shouldCheckToRemoveAllProducts" v-on:confirm="confirmToRemoveAllProducts" v-on:close="closeMaskForcheckToRemoveAllProducts"></mask-for-check-to-remove-all-products>
  </div>
</template>

<script>
    import _ from 'lodash';
    import setting from './setting';
    import util from './util';
    import lang from './lang';
    import StepBar from './components/StepBar.vue';
    import ErrorMessage from './components/ErrorMessage.vue';
    import ProductsList from './components/ProductsList.vue';
    import Comment from './components/Comment.vue';
    import TotalPrice from './components/TotalPrice.vue';
    import ButtonCollection from './components/ButtonCollection.vue';
    import EmptyCart from './components/EmptyCart.vue';
    import MaskForCheckToRemoveAllProducts from './components/MaskForCheckToRemoveAllProducts.vue';

    export default {

        data() {
            return {
                lang,
                loading: true,
                formActionUrl: setting.ACTION_URL,
                defaultActionUrl: setting.DEFAULT_URL,
                productsList: [],
                totalWithCurrency: undefined,
                comment: '',
                errorMessage: [],
                shouldCheckToRemoveAllProducts: false,
                isAE: false,
                isStoreOffer: false,
            };
        },
        computed: {
            anyProductInCart() {
                return this.productsList.length > 0;
            }
        },
        watch: {
            productsList() {
                let quantity = this.calculateProductsListQuantity();
                this.renewCartCountDisplay(quantity);
            }
        },
        components: {
            StepBar,
            ErrorMessage,
            ProductsList,
            Comment,
            TotalPrice,
            ButtonCollection,
            EmptyCart,
            MaskForCheckToRemoveAllProducts
        },
        created() {
            this.getComment();
            this.getCartData();
            this.checkErrorMessage();
        },
        methods: {

            getFormActionUrl() {
                this.formActionUrl = window && window.aerobile && window.aerobile.formActionUrl ? window.aerobile.formActionUrl : setting.ACTION_URL;
            },

            getDefaultActionUrl() {
                this.defaultActionUrl = window && window.aerobile && window.aerobile.defaultUrl ? window.aerobile.defaultUrl : setting.DEFAULT_URL;
            },

            getComment() {
                var domComments = document.getElementById('comments');
                this.comment = domComments ? domComments.innerHTML.trim() : '';
            },

            getCartData(cb) {
                this.loading = true;

                const options = {
                    params: {
                        action: 'getCartData'
                    }
                };
                this.$http.get(setting.API_URL, options)
                    .then((res) => {
                        this.productsList = res.body.products;
                        this.totalWithCurrency = res.body.total;
                        this.isAE = res.body.is_a_e;
                        this.isStoreOffer = res.body.is_store_offer;
                        if (typeof cb === 'function') cb();
                        this.loading = false;
                    });
            },


            checkErrorMessage() {
                if (window && window.aerobile && window.aerobile.errorMessage) this.errorMessage.push(window.aerobile.errorMessage);
            },

            setFlagForQuantityError(products_id) {
                this.productsList = this.productsList.map(product => {
                    if (product.id === products_id) product.flagForQuantityError = true;
                    return product;
                });
            },

            updateQuantityOfSelectedProduct(products_id, qty) {
                if (!products_id || typeof qty !== 'number') return;
                const body = {
                    action: 'updateQuantity',
                    products_id: _.unescape(products_id),
                    quantity: qty,
                };
                this.$http.post(setting.API_URL, body)
                    .then((res) => {
                        let cb;
                        if (!res.body) return this.errorMessage = [util.SOMETHING_IS_WRONG];
                        if (res.body.errorMessage && res.body.errorMessage == util.RENTAL_IS_UNDERSTOCK) {
                            this.errorMessage = [lang.say('ERROR_RENTAL_QUANTITY_INSUFFICIENT')];
                            cb = this.setFlagForQuantityError.bind(this, products_id);
                        }
                        return this.getCartData(cb);
                    });
            },

            removeSelectedProduct(products_id) {
                if (!products_id) return;
                const body = {
                    action: 'remove',
                    products_id: _.unescape(products_id),
                };
                this.$http.post(setting.API_URL, body)
                    .then((res) => {
                        if (!res.body) return this.errorMessage = [util.SOMETHING_IS_WRONG];
                        if (res.body == 'ok') return this.getCartData();
                    });
            },

            openMaskForcheckToRemoveAllProducts() {
                this.shouldCheckToRemoveAllProducts = true;
            },

            closeMaskForcheckToRemoveAllProducts() {
                this.shouldCheckToRemoveAllProducts = false;
            },

            confirmToRemoveAllProducts(isConfirm) {
                if (isConfirm) this.removeAllProducts();
                this.closeMaskForcheckToRemoveAllProducts();
            },

            removeAllProducts() {
                const body = {
                    action: 'remove_all',
                };
                this.$http.post(setting.API_URL, body)
                    .then((res) => {
                        if (!res.body) return this.errorMessage = [util.SOMETHING_IS_WRONG];
                        if (res.body == 'ok') return this.getCartData();

                    });
            },

            applyStoreOffer( isStoreOffer ){

                const body = {
                    action: 'change_store_offer',
                    is_store_offer: isStoreOffer
                };
                this.$http.post(setting.API_URL, body)
                    .then((res) => {
                        if (!res.body || res.body != 'ok') return this.errorMessage = [util.SOMETHING_IS_WRONG];
                        if (res.body == 'ok') return this.getCartData();

                    });

            },

            clearErrorMessage() {
                this.errorMessage = [];
            },

            // 計算購物車內產品數量
            calculateProductsListQuantity() {
                if ( this.productsList.length > 0 ) {
                    let quantity = this.productsList.map(item => item.quantity)
                                   .reduce((acc, cur) => acc + cur);
                    return quantity
                }
                
                return 0
            },

            // 更改vue外面的element
            renewCartCountDisplay(num) {
                let el = document.getElementById('cart-count-contents');
                if (el) {
                    el.textContent = num;
                }
            }
        }
    }
</script>

<style scoped>
    .app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }
    
    h1,
    h2 {
        font-weight: normal;
    }
    
    ul {
        list-style-type: none;
        padding: 0;
    }
    
    li {
        display: inline-block;
        margin: 0 10px;
    }
    
    a {
        color: #42b983;
    }
</style>


// WEBPACK FOOTER //
// App.vue?64b0e372